import React from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { branchData } from "../../../globalApi/GlobalApi";
import { categoryData } from "../../../globalApi/GlobalApi";

export default function HomeCom() {
  const navigate = useNavigate();

  // GET API CATEGORY
  const { data: categoryDatas } = useQuery("categoryData", categoryData);
  // GET API BRANCH
  const { data: branchDatas } = useQuery("branchData", branchData);
  const details = branchDatas?.data || [];
  const branchCount = details?.length;

  const categorydetails = categoryDatas?.data || [];
  const categoryCount = categorydetails?.length;

  const overAllReportDetails = [
    {
      name: "Total Projects ",
      value: "0",
      background: "green",
      path: "/project/projectView",
    },
    {
      name: "Total Expenses",
      value: "0",
      background: "rgb(200, 54, 57)",
      path: "/expenses/ExpensesView",
    },
    {
      name: "Total Category",
      value: `${categoryCount}`,
      background: "rgb(237, 131, 65)",
      path: "/setting/categoryView",
    },
    {
      name: "Total Branches",
      value: ` ${branchCount}`,
      background: "rgb(78, 130, 234)",
      path: "/setting/branchView",
    },
  ];
  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Dashboard</div>
          </header>
          <section className="py-5">
            <div className="reportMainContainer">
              {overAllReportDetails?.map((item, index) => {
                return (
                  <div
                    className="overall-card"
                    key={index}
                    style={{
                      background: item.background,
                      height: "130px",
                      width: "250px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate(item?.path);
                    }}
                  >
                    <div className="overall-text">
                      <div
                        className="overall-value"
                        style={{ color: "#fff", fontSize: "32px" }}
                      >
                        {item.value}
                      </div>
                      <div className="overall-label" style={{ color: "#fff" }}>
                        {item.name}
                      </div>
                    </div>
                    <div
                      className="bg-shape1"
                      style={{ background: "rgba(255, 255, 255, 0.49)" }}
                    ></div>
                    <div
                      className="bg-shape2"
                      style={{ background: "rgba(255, 255, 255, 0.49)" }}
                    ></div>
                  </div>
                );
              })}
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
